module.exports = __webpack_public_path__ + "img/肖祖香.45c6d979.jpg";